import { RECEIVE_USER, SESSION_EXPIRED, UPDATE_USER } from "../../actions/user"
import { Types } from "model/updater"

const defaultState = { }

export default function (state = defaultState, action) {
  switch (action.type) {
    case RECEIVE_USER: {
      const user = action.user
      return { ...state, ...user }
    }
    case UPDATE_USER: {
      return { ...state, ...action.user }
    }
    case SESSION_EXPIRED: {
      return { ...state, ...action.user }
    }
    case Types.UPDATE_SUCCESS:
      if (action.resource === "profile") {
        return { ...state, ...action.payload }
      } else {
        return state
      }
    default:
      return state
  }
}
